/**
 * @generated SignedSource<<02fbd2df765916035ecd5861c60ee20d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usersTable_UsersListFragment$data = {
  readonly Admin: {
    readonly Auth: {
      readonly Users: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly activated: boolean;
            readonly email: string;
            readonly extension: {
              readonly lastSignInAt?: string | null;
            } | null;
            readonly groupAssociations: ReadonlyArray<{
              readonly account: {
                readonly name: string;
              } | null;
              readonly group: {
                readonly id: string;
                readonly name: string;
              } | null;
            }>;
            readonly id: string;
            readonly name: string;
          };
        } | null> | null;
      };
    };
  };
  readonly " $fragmentType": "usersTable_UsersListFragment";
};
export type usersTable_UsersListFragment$key = {
  readonly " $data"?: usersTable_UsersListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"usersTable_UsersListFragment">;
};

import UsersTable_Refetch_graphql from './UsersTable_Refetch.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "Auth",
  "Users"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "nameOrEmail"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": UsersTable_Refetch_graphql
    }
  },
  "name": "usersTable_UsersListFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthAdminSchema",
          "kind": "LinkedField",
          "name": "Auth",
          "plural": false,
          "selections": [
            {
              "alias": "Users",
              "args": [
                {
                  "kind": "Variable",
                  "name": "filterByNameOrEmail",
                  "variableName": "nameOrEmail"
                }
              ],
              "concreteType": "UserConnection",
              "kind": "LinkedField",
              "name": "__UsersTable_Users_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "activated",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "userExtensionKind",
                              "value": "Academies"
                            }
                          ],
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "extension",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lastSignInAt",
                                  "storageKey": null
                                }
                              ],
                              "type": "AcademiesUserExtension",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": "extension(userExtensionKind:\"Academies\")"
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "UserGroupAssociation",
                          "kind": "LinkedField",
                          "name": "groupAssociations",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Account",
                              "kind": "LinkedField",
                              "name": "account",
                              "plural": false,
                              "selections": [
                                (v2/*: any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "UserInAccountGroup",
                              "kind": "LinkedField",
                              "name": "group",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v2/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "4f2d27c436be1a75e64af2a86877c980";

export default node;
